var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharehearts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_659_131219)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.652344,
    width: 41,
    height: 36,
    rx: 18,
    fill: "#1C1C1C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8192 22.2683L20.2004 21.7702C17.983 20.0043 16.5219 18.8422 16.5219 17.4159C16.5219 16.2537 17.5618 15.3406 18.8854 15.3406C19.6331 15.3406 20.3465 15.65 20.8192 16.133C21.2919 15.65 22.0053 15.3406 22.753 15.3406C24.0766 15.3406 25.1165 16.2537 25.1165 17.4159C25.1165 18.8422 23.6554 20.0043 21.438 21.7702L20.8192 22.2683ZM14.8029 11.7031H26.8355C27.2914 11.7031 27.7286 11.8621 28.051 12.1452C28.3733 12.4282 28.5544 12.8121 28.5544 13.2124V23.7776C28.5544 24.1779 28.3733 24.5618 28.051 24.8449C27.7286 25.1279 27.2914 25.2869 26.8355 25.2869H14.8029C14.347 25.2869 13.9098 25.1279 13.5874 24.8449C13.2651 24.5618 13.084 24.1779 13.084 23.7776V13.2124C13.084 12.8121 13.2651 12.4282 13.5874 12.1452C13.9098 11.8621 14.347 11.7031 14.8029 11.7031ZM14.8029 13.2124V23.7776H26.8355V13.2124H14.8029Z",
    fill: "url(#paint0_linear_659_131219)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_659_131219",
    x: -4.5,
    y: -4.34766,
    width: 51,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_659_131219"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_659_131219",
    result: "effect2_innerShadow_659_131219"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_659_131219",
    x1: 20.8192,
    y1: 9.25804,
    x2: 20.8192,
    y2: 27.4603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharehearts);
export default __webpack_public_path__ + "static/media/sharehearts.4af319a928f3f1562455eef1d1832664.svg";
export { ForwardRef as ReactComponent };